import { fromJS, List } from 'immutable';

import { RENAME_ID } from 'redux/reducers/orders';
import { LOGOUT } from './user';

export const ADD = 'kroost/photos/ADD';
export const FILTER = 'kroost/photos/FILTER';
export const SET_ALL = 'kroost/photos/SET_ALL';
export const ADD_EXIF_TEST = 'kroost/photos/ADD_EXIF_TEST';

export const SET_UPLOAD = 'kroost/photos/SET_UPLOAD';
export const TOGGLE_SAVED = 'kroost/photos/TOGGLE_SAVED';
export const TOGGLE_FAVORITE = 'kroost/photos/TOGGLE_FAVORITE';
export const UPDATE_PREVIEW = 'kroost/photos/UPDATE_PREVIEW';

// Initial routing state
const initialState = fromJS({});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_ALL:
      return state.update(action.orderId, List(), photos =>
        photos
          .concat(action.photos)
          .groupBy(x => x.get('simpleId'))
          .map(x => x.first())
          .toList()
      );
    case RENAME_ID: {
      const photos = state.get(action.oldId);

      if (!photos) {
        return state;
      }

      return state.delete(action.oldId).set(action.newId, photos);
    }
    case LOGOUT:
      return fromJS({});
    default:
      return state;
  }
}

export function add(photos) {
  return {
    type: ADD,
    photos,
  };
}

export function addTestPhotos(items) {
  return {
    type: ADD_EXIF_TEST,
    items,
  };
}

export function setAll(orderId, photos) {
  return {
    type: SET_ALL,
    orderId,
    photos,
  };
}

export function filter() {
  return {
    type: FILTER,
  };
}

export function toggleSaved(orderId, simpleId) {
  return {
    type: TOGGLE_SAVED,
    orderId,
    simpleId,
  };
}

export function toggleFavorite(orderId, currentSpread, simpleId) {
  return {
    type: TOGGLE_FAVORITE,
    orderId,
    currentSpread,
    simpleId,
  };
}

export function setUpload(orderId, simpleId, upload) {
  return {
    type: SET_UPLOAD,
    orderId,
    simpleId,
    upload,
  };
}

export function updatePreview(orderId, momentId) {
  return {
    type: UPDATE_PREVIEW,
    orderId,
    momentId,
  };
}



// WEBPACK FOOTER //
// ./app/redux/reducers/photos.js